var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"variant":"link"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('b-icon',{staticClass:"font-size-16",attrs:{"icon":"three-dots"}})]},proxy:true}])},[_c('contacts',{attrs:{"hospital":_vm.hospital}}),_c('licenses',{attrs:{"hospital":_vm.hospital}}),_c('organs',{attrs:{"hospital":_vm.hospital}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }